import React, { useState } from "react";

const WhyChooseOne = () => {
  const [activeTab, setActiveTab] = useState("itemOne");

  const tabContent = {
    itemOne: {
      title: "Instant Cab Booking",
      description:
        "Lotus Cab makes booking your ride simple and quick. With just a few clicks, you can schedule your ride anytime, anywhere across the USA.",
      list: [
        "Easy Online Booking",
        "24/7 Service Availability",
        "Quick Confirmation",
        "Multiple Payment Options",
        "Scheduled & Instant Rides",
        "User-Friendly Experience",
      ],
    },
    itemTwo: {
      title: "Live Ride Tracking",
      description:
        "Stay informed with real-time GPS tracking. Lotus Cab ensures safety and transparency by allowing you to track your ride from pickup to destination.",
      list: [
        "Real-Time GPS Tracking",
        "Driver Details Before Arrival",
        "Estimated Time Updates",
        "Safe & Secure Monitoring",
        "Trip Sharing Option",
        "Reliable Route Navigation",
      ],
    },
    itemThree: {
      title: "Affordable & Transparent Pricing",
      description:
        "With Lotus Cab, what you see is what you pay. We provide competitive pricing without hidden charges, ensuring value for every ride.",
      list: [
        "No Hidden Charges",
        "Upfront Fare Estimates",
        "Budget-Friendly Rates",
        "Special Discounts & Offers",
        "Corporate Ride Packages",
        "Multiple Payment Methods",
      ],
    },
    itemFour: {
      title: "Premium & Comfortable Transport",
      description:
        "Experience comfort and reliability with our well-maintained fleet and professional drivers dedicated to delivering exceptional service.",
      list: [
        "Clean & Sanitized Vehicles",
        "Professional & Verified Drivers",
        "Comfortable Seating",
        "Air-Conditioned Rides",
        "Luxury Ride Options",
        "Airport & Long-Distance Travel",
      ],
    },
  };

  const tabButtons = {
    // itemOne: "Instant Booking",
    // itemTwo: "Live Tracking",
    // itemThree: "Best Pricing",
    // itemFour: "Premium Transport",
  };

  return (
    <section className="why-choose-one section-space-bottom">
      <div className="container">

        {/* SECTION TITLE */}
        <div className="sec-title sec-title--center">
          <div className="sec-title__top wow fadeInUp">
            <div className="sec-title__shape"></div>
            <h6 className="sec-title__tagline">Why Choose Lotus Cab</h6>
            <div className="sec-title__shape"></div>
          </div>

          <h3 className="sec-title__title wow fadeInUp">
            Most Trusted  Service
          </h3>
        </div>

        {/* TABS */}
        <div className="tabs-box wow fadeInUp">

          {/* TAB BUTTONS */}
          <div className="tab-buttons">
            {Object.keys(tabButtons).map((key) => (
              <button
                key={key}
                onClick={() => setActiveTab(key)}
                className={`tab-btn ${
                  activeTab === key ? "active-btn" : ""
                }`}
              >
                <span></span> {tabButtons[key]}
              </button>
            ))}
          </div>

          {/* TAB CONTENT */}
          <div className="tabs-content">
            <div className="why-choose-one__item active-tab">
              <div
                className="why-choose-one__item__bg"
                style={{
                  backgroundImage:
                    "url(assets/images/shapes/contact-bg-1-1.jpg)",
                }}
              ></div>

              <div className="row gutter-y-40 align-items-center">

                {/* LEFT CONTENT */}
                <div className="col-lg-7">
                  <div className="why-choose-one__left">
                    <h2 className="why-choose-one__title">
                      {tabContent[activeTab].title}
                    </h2>

                    <p className="why-choose-one__text">
                      {tabContent[activeTab].description}
                    </p>

                    <ul className="why-choose-one__list">
                      {tabContent[activeTab].list.map((item, index) => (
                        <li key={index}>
                          <i className="icon-check-mark"></i> {item}
                        </li>
                      ))}
                    </ul>

                    <div className="why-choose-one__btn-box">
                      <a
                        href="/booking"
                        className="why-choose-one__btn cityride-btn cityride-btn--secondary"
                      >
                        <span className="cityride-btn__icon">
                          <i className="icon-front-car"></i>
                        </span>
                        <span>Book Your Lotus Ride</span>
                      </a>
                      <div className="why-choose-one__btn__border"></div>
                    </div>
                  </div>
                </div>

                {/* RIGHT IMAGE */}
                <div className="col-lg-5">
                  <div className="why-choose-one__thumb">
                    <img
                      src="/images/about.png"
                      alt="Lotus Cab Service"
                    />
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>

      {/* SHAPES */}
      <div className="why-choose-one__shape-left">
        <div className="why-choose-one__shape-left__one"></div>
        <div className="why-choose-one__shape-left__two"></div>
      </div>

      <div className="why-choose-one__shape-right">
        <div className="why-choose-one__shape-right__one"></div>
        <div className="why-choose-one__shape-right__two"></div>
      </div>

    </section>
  );
};

export default WhyChooseOne;
